import { render } from "./CreateRoom.vue?vue&type=template&id=1c2a989a&scoped=true&lang=pug"
import script from "./CreateRoom.vue?vue&type=script&lang=js"
export * from "./CreateRoom.vue?vue&type=script&lang=js"

import "./CreateRoom.vue?vue&type=style&index=0&id=1c2a989a&scoped=true&lang=sass"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1c2a989a"]])

export default __exports__